module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"close":"Закрыть","save":"Сохранить","question":"Задайте свой вопрос в свободной форме","questionHint":"Максимальное количество символов - 200","preview":"Предпросмотр"}}')
  delete Component.options._Ctor
}
